import React from "react";

type Props = {
  label: string;
};

export function Badge({ label }: Props) {
  return (
    <div
      className={`
     cw-body-sm cw-text-11 cw-font-bold cw-uppercase
     cw-px-[5px] cw-rounded-[3px] cw-w-fit
   cw-text-accent cw-bg-accent
     `}
    >
      {label}
    </div>
  );
}
